import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useRecommendations } from '@ynap/recommendations-hook';
import { useIntelistyleWiw } from './use-intelistyle-wiw';
import WearItWithCarousel from './RecommendationsCarousels/WearItWithCarousel';
import YouMayAlsoLikeCarousel from './RecommendationsCarousels/YouMayAlsoLikeCarousel';
import RecentlyViewedCarousel from './RecommendationsCarousels/RecentlyViewedCarousel';

const Recommendations = (props) => {
    const {
        messages,
        colourPartNumber,
        modelPartNumber,
        ymalFirst,
        tracking,
        isCarouselVisible,
        useOutfitView = false,
        carouselConfig,
        isFullWidth = false,
        addToCart,
        isWithAddToBag = false,
        useDefaultCarouselIndex,
        className,
        withQuickAdd = false,
        variation,
        images,
        reducedMode,
        viewSimilarAndShopMore = null,
    } = props;

    const recommendations = useRecommendations({ ...props, partNumber: colourPartNumber });

    const intelistyleWiw = useIntelistyleWiw({
        partNumber: colourPartNumber,
    });

    const WiwCarouselComponent = (
        <WearItWithCarousel
            messages={messages}
            recommendations={recommendations}
            intelistyleWiw={intelistyleWiw}
            useOutfitView={useOutfitView}
            reducedMode={reducedMode}
            colourPartNumber={colourPartNumber}
            tracking={tracking}
            variation={variation}
            images={images}
            isCarouselVisible={isCarouselVisible}
            addToCart={addToCart}
            isWithAddToBag={isWithAddToBag}
            className={className}
            useDefaultCarouselIndex={useDefaultCarouselIndex}
            withQuickAdd={withQuickAdd}
        />
    );

    return (
        <Fragment>
            {!ymalFirst && WiwCarouselComponent}
            <YouMayAlsoLikeCarousel
                messages={messages}
                recommendations={recommendations}
                colourPartNumber={colourPartNumber}
                tracking={tracking}
                isCarouselVisible={isCarouselVisible}
                isFullWidth={isFullWidth}
                addToCart={addToCart}
                isWithAddToBag={isWithAddToBag}
                className={className}
                useDefaultCarouselIndex={useDefaultCarouselIndex}
                withQuickAdd={withQuickAdd}
                variation={variation}
                reducedMode={reducedMode}
                carouselConfig={carouselConfig}
                viewSimilarAndShopMore={viewSimilarAndShopMore}
            />
            {ymalFirst && WiwCarouselComponent}
            <RecentlyViewedCarousel
                messages={messages}
                colourPartNumber={colourPartNumber}
                tracking={tracking}
                isCarouselVisible={isCarouselVisible}
                isFullWidth={isFullWidth}
                addToCart={addToCart}
                isWithAddToBag={isWithAddToBag}
                className={className}
                useDefaultCarouselIndex={useDefaultCarouselIndex}
                withQuickAdd={withQuickAdd}
                variation={variation}
                reducedMode={reducedMode}
                carouselConfig={carouselConfig}
                modelPartNumber={modelPartNumber}
            />
        </Fragment>
    );
};

Recommendations.propTypes = {
    messages: PropTypes.shape({
        wearItWith: PropTypes.shape({
            heading: PropTypes.func.isRequired,
        }).isRequired,
        youMayAlsoLike: PropTypes.shape({
            heading: PropTypes.func.isRequired,
        }).isRequired,
    }),
    colourPartNumber: PropTypes.string.isRequired,
    modelPartNumber: PropTypes.string.isRequired,
    variation: PropTypes.string,
    description: PropTypes.string.isRequired,
    isCarouselVisible: PropTypes.bool,
    isWithAddToBag: PropTypes.bool,
    ymalFirst: PropTypes.bool,
    tracking: PropTypes.shape({
        wiw: PropTypes.func,
        ymal: PropTypes.func,
        rv: PropTypes.func,
    }),
    recommendationsToFetch: PropTypes.func,
    bypassWCSRecommendations: PropTypes.bool,
    useOutfitView: PropTypes.bool,
    className: PropTypes.string,
    carouselConfig: PropTypes.object,
    addToCart: PropTypes.func,
    useDefaultCarouselIndex: PropTypes.bool,
    isFullWidth: PropTypes.bool,
    withQuickAdd: PropTypes.bool,
    useOutfitCarousel: PropTypes.bool,
    reducedMode: PropTypes.bool,
    intelistyleWiw: PropTypes.array,
    images: PropTypes.array,
    viewSimilarAndShopMore: PropTypes.element,
};

Recommendations.defaultProps = {
    isCarouselVisible: false,
    useDefaultCarouselIndex: true,
};

export default Recommendations;
